import { createAction } from '@reduxjs/toolkit';
import { MSG_TYPES } from '../constants';

export const setReceiverInfoAction = createAction(MSG_TYPES.SET_RECEIVER_INFO);
export const setUserListAction = createAction(MSG_TYPES.SET_USER_LIST);

export const setUserList = (userList) => (dispatch) => {
  dispatch(setUserListAction(userList));
};
